/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-23 17:10:43
 */
import { TableColumnType, Button, Popconfirm } from 'antd'
import React from 'react'
import { ReactElement } from 'react'
import { getUploadStatus } from '../../../../models/OReplaceMakeSlice'

export const Columns = (onClick: (type: 'upload' | 'cancelUpload', tenant: any) => void, startIndex: number,  loading?: any,selectId?:any): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门诊号',
      align: 'center',
      dataIndex: 'outpatientNum',
    },
    {
      title: '患者姓名',
      align: 'center',
      dataIndex: 'recipientName',
    },
    {
      title: '处方金额',
      align: 'center',
      dataIndex: 'money',
    },
    {
      title: '药方金额',
      align: 'center',
      key: 'drugMoney',
      render: (_, t) => t.drugMoney.toFixed(2)
    },
    {
      title: '代煎类别',
      align: 'center',
      dataIndex: 'typeName',
    },
    {
      title: '结算状态',
      align: 'center',
      key: 'state',
      render: (_, t) => (
        t.state === 5 ? '已退费' : '已结算'
      )
    },
    {
      title: '开单时间',
      align: 'center',
      dataIndex: 'createTime',
      key: 'createTime',
    },
  ]
}
